module.exports = __webpack_public_path__ + "img/middleC.b555d2b1.png";